import { noop } from "lodash-es";
import { useState } from "react";
import type { ContactDialogStep } from "web_myplann/Shared/Types/ContactDialogStep";

type Params = {
	open: boolean;
	onClose: () => void;
	onConfirm: (onSuccess: () => void) => void;
	optimistic: boolean;
};

export const useContactDialogStep = ({
	open,
	onClose,
	onConfirm,
	optimistic,
}: Params) => {
	const [step, setStep] = useState<ContactDialogStep>("contact");
	const [wasOpen, setWasOpen] = useState(open);

	if (open !== wasOpen) {
		setWasOpen(open);
		if (open) {
			setStep("contact");
		}
	}

	const showSuccess = () => setStep("success");

	const confirm = () => {
		if (optimistic) {
			showSuccess();
			onConfirm(noop);
			return;
		}
		onConfirm(showSuccess);
	};

	return { step, close: onClose, confirm };
};
